import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import GestionTresorerieConsolidee from "./GestionTresorerieConsolidee";
import TreasuryMobile from "../mobile/tresorerie/TreasuryMobile";

export default function ResponsiveGestionTresorerieConsolidee(props) {
  return useIsMobile() ? <TreasuryMobile consolidated {...props} /> : <GestionTresorerieConsolidee {...props} />;
}
